<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    :width="['zh', 'fa'].includes($i18n.locale) ? '800px' : '1000px'"
    append-to-body
    destroy-on-close
  >
    <div slot="title" class="header-title">
      <img src="@/assets/image/newIssue.png" alt="" />
      <span>{{ title }}</span>
    </div>
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      :label-width="labelWidth"
    >
      <!-- 基本信息 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>{{ $t("zlfk.jbxx") }}</span>
        </div>
        <!-- 故障发生日期 -->
        <el-form-item :label="$t('zlfk.gzfsrq') + ':'" prop="happenDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.happenDate"
            :placeholder="$t('placeholder.select')"
          />
        </el-form-item>
        <!-- 故障发生地点 -->
        <el-form-item :label="$t('zlfk.gzfsdd') + ':'" prop="happenPlace">
          <el-input
            v-model="form.happenPlace"
            maxlength="200"
            :placeholder="$t('placeholder.enter')"
          />
        </el-form-item>
        <!-- 报修日期 -->
        <el-form-item :label="$t('seek.warrantyDate') + ':'" prop="repairDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.repairDate"
            :placeholder="$t('placeholder.select')"
          />
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item
          :label="$t('restockInfo.yzcd') + ':'"
          prop="severityLevel"
        >
          <el-select filterable clearable v-model="form.severityLevel">
            <el-option
              v-for="(item, index) in severityData"
              :key="index"
              :label="item.label"
              :value="item.code"
            >
              <el-tooltip placement="right" effect="light">
                <div
                  slot="content"
                  class="severityTips"
                  v-html="item['desc' + $i18n.locale]"
                ></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 是否重点问题 -->
        <el-form-item :label="$t('zlfk.sfzdwt') + ':'" prop="importantType">
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item
          v-if="form.importantType === 1"
          :label="$t('zlfk.zdwtms') + ':'"
          prop="importantDescribe"
        >
          <el-input
            v-model="form.importantDescribe"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item :label="$t('zlfk.sfywxcs') + ':'" prop="serviceMeasure">
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 市场维修措施 -->
        <el-form-item
          :label="$t('restockInfo.cswxcs') + ':'"
          prop="marketService"
          v-if="form.serviceMeasure == 1"
        >
          <el-input
            v-model="form.marketService"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item :label="$t('zlfk.lztype') + ':'" prop="componentCategory">
          <el-select v-model="form.componentCategory" filterable clearable>
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get($i18n.locale)]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 零部件批次信息 -->
        <el-form-item :label="$t('zlfk.lzpcinfo') + ':'" prop="componentBatchs">
          <el-input
            v-model="form.componentBatchs"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 发动机型号 -->
        <el-form-item
          :label="$t('seek.onlyEngine') + ':'"
          prop="engineModel"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineModel"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 发动机号 -->
        <el-form-item
          :label="$t('seek.engineNUmber') + ':'"
          prop="engineNumber"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 动力电池号 -->
        <el-form-item
          :label="$t('restockInfo.dldch') + ':'"
          prop="batteryNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.batteryNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 电机号 -->
        <el-form-item
          :label="$t('climant.djNumer') + ':'"
          prop="motorNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.motorNumber"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 订单号 -->
        <el-form-item :label="$t('cart.orderNumber') + ':'" prop="orderNum">
          <el-input  v-model="form.orderNum" :placeholder="$t('placeholder.enter')" />
        </el-form-item>
        <!-- 订单数量 -->
        <el-form-item :label="$t('zlfk.orderNum') + ':'" prop="carTotal">
          <el-input-number
            :controls="false"
            :precision="0"
            v-model="form.carTotal"
            :placeholder="$t('home.placeholder')"
          >
          </el-input-number>
        </el-form-item>
        <!-- 故障数量 -->
        <el-form-item :label="$t('zlfk.gznum') + ':'" prop="faultNumber">
          <el-input-number
            :controls="false"
            :precision="0"
            v-model="form.faultNumber"
            :placeholder="$t('home.placeholder')"
          >
          </el-input-number>
        </el-form-item>
        <!-- 疑似/祸首件代码 -->
        <el-form-item
          :label="$t('seek.culpritCode') + ':'"
          prop="suspectPartNumber"
        >
          <div class="searchFlex">
            <el-input
              v-model="form.suspectPartNumber"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
            <el-button
              class="primary-btn"
              type="primary"
              @click="handlePartSearch"
              >{{ $t("home.query") }}</el-button
            >
          </div>
        </el-form-item>
        <!-- 疑似/祸首件名称 -->
        <el-form-item
          :label="$t('seek.culpritName') + ':'"
          prop="suspectPartName"
        >
          <el-input
            v-model="form.suspectPartName"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 供应商代码/名称 -->
        <!-- <el-form-item :label="$t('restockInfo.supplierInfo')+':'" prop="supplierInfo">
          <el-input v-model="form.supplierInfo" :placeholder="$t('placeholder.enter')"></el-input>
        </el-form-item> -->
      </div>

      <!-- 问题描述 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/wtmsIcon.png" alt="" />
          {{ $t("zlfk.wtms") }}
        </div>
        <!-- 故障描述 -->
        <el-form-item
          :label="$t('restockInfo.gzxxms') + ':'"
          prop="questionContent"
        >
          <el-input
            v-model="form.questionContent"
            type="textarea"
            :placeholder="$t('placeholder.enter')"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 重复性 -->
        <el-form-item :label="$t('restockInfo.cfx') + ':'" prop="repeatability">
          <el-radio-group v-model="form.repeatability">
            <el-radio :label="0">{{ $t("restockInfo.exist") }}</el-radio>
            <el-radio :label="1">{{ $t("restockInfo.occasional") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 有无超载 -->
        <el-form-item :label="$t('seek.overload') + ':'" prop="overload">
          <el-radio-group v-model="form.overload">
            <el-radio :label="0">{{ $t("restockInfo.have") }}</el-radio>
            <el-radio :label="1">{{ $t("restockInfo.not") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 行驶工况 -->
        <el-form-item
          :label="$t('seek.drivingConditions') + ':'"
          prop="drivingCondition"
        >
          <el-input
            v-model="form.drivingCondition"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 行驶路况 -->
        <el-form-item :label="$t('seek.road') + ':'" prop="roadCondition">
          <el-input
            v-model="form.roadCondition"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 天气情况 -->
        <el-form-item :label="$t('seek.weather') + ':'" prop="weatherCondition">
          <el-input
            v-model="form.weatherCondition"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 加装情况 -->
        <el-form-item
          :label="$t('restockInfo.jzqk') + ':'"
          prop="modificationStatus"
        >
          <el-input
            v-model="form.modificationStatus"
            :placeholder="$t('placeholder.enter')"
          ></el-input>
        </el-form-item>
        <!-- 附件 -->
        <!-- <el-form-item :label="$t('zlfk.fj')+':'" prop="faultCommonFiles">
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCommonFiles"
            :httpRequest="action"
          />
        </el-form-item> -->
      </div>
      <!-- 图片和视频 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/ImgIcon.png" alt="" />
          {{ $t("restockInfo.imgVideo") }}
        </div>
        <fileUploadTips></fileUploadTips>
        <!-- 是否有故障视频/图片 -->
        <el-form-item :label="$t('restockInfo.gzfj') + ':'" prop="faultVideo">
          <el-radio-group v-model="form.faultVideo">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="faultVideoFiles"
          v-if="form.faultVideo == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultVideoFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有故障代码 -->
        <el-form-item :label="$t('restockInfo.gzdm') + ':'" prop="faultCode">
          <el-radio-group v-model="form.faultCode">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('cart.remark') + ':'"
          prop="faultCodeRemark"
          v-if="form.faultCode == 1"
        >
          <el-input
            v-model="form.faultCodeRemark"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="faultCodeFiles"
          v-if="form.faultCode == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCodeFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有其他说明 -->
        <el-form-item
          :label="$t('restockInfo.qtsm') + ':'"
          prop="otherInstructions"
        >
          <el-radio-group v-model="form.otherInstructions">
            <el-radio :label="1">{{ $t("seek.yes") }}</el-radio>
            <el-radio :label="0">{{ $t("seek.no") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('cart.remark') + ':'"
          prop="otherRemark"
          v-if="form.otherInstructions == 1"
        >
          <el-input
            v-model="form.otherRemark"
            :placeholder="$t('placeholder.enter')"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('zlfk.fj') + ':'"
          prop="otherFiles"
          v-if="form.otherInstructions == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.otherFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
      </div>
      <!-- 发动机保养记录 -->
      <div v-if="form.componentCategory == '1'">
        <!-- 发动机保养记录 -->
        <div class="titleTips">
          <img src="@/assets/image/engineRecords.png" alt="" />
          {{ $t("home.engineRecord") }}
        </div>
        <div class="maintenance-records">
          <div class="record-header">
            <el-button
              type="primary"
              @click="addEngineRecord"
              class="add-record-btn"
              icon="el-icon-plus"
            >
              {{ $t("zlfk.tj") }}{{ $t("home.engineRecord") }}
            </el-button>
          </div>
          <div
            v-for="(record, index) in form.engineRecordList"
            :key="'engine-' + index"
            class="record-item"
          >
            <div class="record-form">
              <div class="remove-record">
                <el-button
                  type="text"
                  @click="removeEngineRecord(index)"
                  class="remove-record-btn"
                  icon="el-icon-delete"
                >
                  {{ $t("cart.delete") }}
                </el-button>
              </div>

              <el-form-item
                :label="$t('home.date') + ':'"
                :prop="`engineRecordList[${index}].time`"
                :rules="[{ required: true, message: ' ' }]"
                class="record-form-item"
                :label-width="recordLabelWidth"
              >
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="record.time"
                  :placeholder="$t('placeholder.select')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.mileage') + ':'"
                :prop="`engineRecordList[${index}].mileage`"
                :rules="[{ required: true, message: ' ' }]"
                class="record-form-item"
                :label-width="recordLabelWidth"
              >
                <el-input-number
                  class="number-input"
                  :controls="false"
                  :precision="0"
                  v-model="record.mileage"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input-number>
                <div class="number-input-append">km</div>
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.bycontent') + ':'"
                :prop="`engineRecordList[${index}].content`"
                class="record-form-item content-item"
                :label-width="recordLabelWidth"
              >
                <el-input
                  v-model="record.content"
                  type="textarea"
                  :placeholder="$t('placeholder.enter')"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  maxlength="500"
                  show-word-limit
                />
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.fj') + ':'"
                :prop="`engineRecordList[${index}].photos`"
                class="record-form-item photos-item"
                :label-width="recordLabelWidth"
              >
                <drag-upload
                  ref="uploadFile"
                  :accessoryList.sync="record.photos"
                  :httpRequest="action"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <!-- 变速器保养记录 -->
      <div v-if="form.componentCategory == '2'">
        <!-- 变速器保养记录 -->
        <div class="titleTips">
          <img src="@/assets/image/gearbox.png" alt="" />
          {{ $t("home.transmissionRecord") }}
        </div>
        <div class="maintenance-records">
          <div class="record-header">
            <el-button
              type="primary"
              @click="addTransmissionRecord"
              class="add-record-btn"
              icon="el-icon-plus"
            >
              {{ $t("zlfk.tj") }}{{ $t("home.transmissionRecord") }}
            </el-button>
          </div>
          <div
            v-for="(record, index) in form.transmissionRecordList"
            :key="'transmission-' + index"
            class="record-item"
          >
            <div class="record-form">
              <div class="remove-record">
                <el-button
                  type="text"
                  @click="removeTransmissionRecord(index)"
                  class="remove-record-btn"
                  icon="el-icon-delete"
                >
                  {{ $t("cart.delete") }}
                </el-button>
              </div>
              <el-form-item
                :label="$t('home.date') + ':'"
                :prop="`transmissionRecordList[${index}].time`"
                :rules="[{ required: true, message: ' ' }]"
                class="record-form-item"
                :label-width="recordLabelWidth"
              >
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="record.time"
                  :placeholder="$t('placeholder.select')"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.mileage') + ':'"
                :prop="`transmissionRecordList[${index}].mileage`"
                :rules="[{ required: true, message: ' ' }]"
                class="record-form-item"
                :label-width="recordLabelWidth"
              >
                <el-input-number
                  class="number-input"
                  :controls="false"
                  :precision="0"
                  v-model="record.mileage"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input-number>
                <div class="number-input-append">km</div>
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.bycontent') + ':'"
                :prop="`transmissionRecordList[${index}].content`"
                class="record-form-item content-item"
                :label-width="recordLabelWidth"
              >
                <el-input
                  v-model="record.content"
                  type="textarea"
                  :placeholder="$t('placeholder.enter')"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  maxlength="500"
                  show-word-limit
                />
              </el-form-item>
              <el-form-item
                :label="$t('zlfk.fj') + ':'"
                :prop="`transmissionRecordList[${index}].photos`"
                class="record-form-item photos-item"
                :label-width="recordLabelWidth"
              >
                <drag-upload
                  ref="uploadFile"
                  :accessoryList.sync="record.photos"
                  :httpRequest="action"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        class="primary-btn lang-but"
        type="primary"
        @click="handleSave"
      >
        {{ $t("seek.submit") }}
      </el-button>
      <el-button
        class="primary-btn lang-but"
        plain
        @click="dialogVisible = false"
        >{{ $t("seek.cancel") }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  afterProblemEditApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import { uploadUrl } from "@/util/url";
import faultData from "@/mixins/faultData";
import fileUploadTips from "@/components/fileUpload/fileUploadTips";

export default {
  components: { fileUploadTips },
  mixins: [faultData],
  props: {},
  data() {
    return {
      action: "/customer/claim/upload",
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      operate: "", // 操作方式：edit-直接编辑
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "160px",
        en: "320px",
        es: "295px",
        ru: "335px",
        vi: "265px",
      };
      return widthMap[this.$i18n.locale] || "210px";
    },
    recordLabelWidth() {
      const widthMap = {
        zh: "85px",
        en: "160px",
        es: "230px",
        ru: "310px",
      };
      return widthMap[this.$i18n.locale] || "165px";
    },
    // 表单验证规则
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"],
        message: this.$t("restockInfo.nullTip"),
      };
      return {
        ...Object.fromEntries(
          [
            "happenDate",
            "repairDate",
            "severityLevel",
            "importantType",
            "importantDescribe",
            "serviceMeasure",
            "marketService",
            "componentCategory",
            "engineModel",
            "engineNumber",
            "faultNumber",
            "orderNum",
            "carTotal",
            "questionContent",
            "repeatability",
            "faultVideo",
            "faultVideoFiles",
            "faultCode",
            "faultCodeRemark",
            "otherInstructions",
            "otherRemark",
          ].map((field) => [field, commonRule])
        ),
      };
    },
  },
  created() {},
  methods: {
    async handleOrder() {
      if (this.form.orderNum) {
        const res = await getVehicleAmountByOrderNumber(this.form.orderNum);
        if (res.status == 0) {
          this.form.carTotal = res.data || "0";
        }
      }
    },
    // 初始化
    async init(title, data = {}, type) {
      this.title = title;
      this.operate = type || "";
      this.dialogVisible = true;
      this.form = this.getForm(data);
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
        this.detectLabelOverflow();
      });
    },
    // 获取疑似/祸首件名称
    async handlePartSearch() {
      this.getCheckPart();
    },
    // 获取表单对象
    getForm(data = {}) {
      return {
        happenDate: data.happenDate || "",
        happenPlace: data.happenPlace || "",
        repairDate: data.repairDate || "",
        severityLevel: data.severityLevel || "",
        importantType: data.importantType ?? 1,
        importantDescribe: data.importantDescribe || "",
        serviceMeasure: data.serviceMeasure ?? 1,
        marketService: data.marketService || "",
        componentCategory: Number(data.componentCategory) || "",
        componentBatchs: data.componentBatchs || "",
        engineModel: data.engineModel || "",
        engineNumber: data.engineNumber || "",
        batteryNumber: data.batteryNumber || "",
        motorNumber: data.motorNumber || "",
        nowTaskId: data.nowTaskId || "",
        orderNum: data.orderNum || "",
        carTotal: data.carTotal || undefined,
        faultNumber: data.faultNumber || undefined,
        suspectPartName: data.suspectPartName || "",
        suspectPartNumber: data.suspectPartNumber || "",
        supplierInfo: data.supplierInfo || "",
        questionContent: data.questionContent || "",
        repeatability: data.repeatability || 0,
        overload: data.overload || 1,
        drivingCondition: data.drivingCondition || "",
        roadCondition: data.roadCondition || "",
        weatherCondition: data.weatherCondition || "",
        modificationStatus: data.modificationStatus || "",
        faultCommonFiles: this.convertArrayData(data.faultCommonFiles),
        faultVideo: data.faultVideo ?? 1,
        faultVideoFiles: this.convertArrayData(data.faultVideoFiles),
        faultCode: data.faultCode ?? 1,
        faultCodeRemark: data.faultCodeRemark || "",
        faultCodeFiles: this.convertArrayData(data.faultCodeFiles),
        otherInstructions: data.otherInstructions ?? 1,
        otherRemark: data.otherRemark || "",
        otherFiles: this.convertArrayData(data.otherFiles),
        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",
        questionNum: data.questionNum || "",
        status: data.status || 0,
        engineRecordList: data.maintenanceRecordInfo
          ? this.formatMaintenanceRecords(
              data.maintenanceRecordInfo.engineRecordList || []
            )
          : [],
        transmissionRecordList: data.maintenanceRecordInfo
          ? this.formatMaintenanceRecords(
              data.maintenanceRecordInfo.transmissionRecordList || []
            )
          : [],
        maintenanceRecordInfo: data.maintenanceRecordInfo,
        maintenanceRecord: data.maintenanceRecord,
      };
    },
    // 格式化保养记录数据
    formatMaintenanceRecords(records) {
      if (Array.isArray(records)) {
        // 如果是新格式的数组对象
        return records.map((record) => ({
          time: record.time || "",
          mileage: record.mileage || undefined,
          content: record.content || "",
          photos: record.photos || [],
        }));
      } else {
        // 如果是旧格式的图片数组，转换为新格式
        return records
          ? [{ time: "", mileage: undefined, content: "", photos: records }]
          : [];
      }
    },
    // 添加发动机保养记录
    addEngineRecord() {
      this.form.engineRecordList.push({
        time: "",
        mileage: undefined,
        content: "",
        photos: [],
      });
    },
    // 删除发动机保养记录
    removeEngineRecord(index) {
      this.form.engineRecordList.splice(index, 1);
    },
    // 添加变速器保养记录
    addTransmissionRecord() {
      this.form.transmissionRecordList.push({
        time: "",
        mileage: undefined,
        content: "",
        photos: [],
      });
    },
    // 删除变速器保养记录
    removeTransmissionRecord(index) {
      this.form.transmissionRecordList.splice(index, 1);
    },
    // 获取提示信息
    getRequiredTips(object) {
      const propLabelMap = {
        happenDate: "zlfk.gzfsrq",
        repairDate: "seek.warrantyDate",
        severityLevel: "restockInfo.yzcd",
        importantType: "zlfk.sfzdwt",
        importantDescribe: "zlfk.zdwtms",
        serviceMeasure: "zlfk.sfywxcs",
        marketService: "restockInfo.cswxcs",
        componentCategory: "zlfk.lztype",
        engineModel: "seek.onlyEngine",
        engineNumber: "seek.engineNUmber",
        faultNumber: "zlfk.gznum",
        questionContent: "restockInfo.gzxxms",
        repeatability: "restockInfo.cfx",
        // overload: 'seek.overload',
        faultVideo: "restockInfo.gzfj",
        faultVideoFiles: "zlfk.fj",
        faultCode: "restockInfo.gzdm",
        faultCodeRemark: "cart.remark",
        otherInstructions: "restockInfo.qtsm",
        otherRemark: "cart.remark",
      };
      const recordFieldLabelMap = {
        time: "home.date",
        mileage: "zlfk.mileage",
      };
      let errorLabels = [];
      if (object) {
        Object.keys(object).forEach((prop) => {
          let label = "";
          if (prop === "faultVideoFiles") {
            label = `${this.$t("restockInfo.gzTitle")}-${this.$t("zlfk.fj")}`;
          } else if (prop === "faultCodeRemark") {
            label = `${this.$t("restockInfo.gzcode")}-${this.$t("cart.remark")}`;
          } else if (prop === "otherRemark") {
            label = `${this.$t("restockInfo.otherInfo")}-${this.$t("cart.remark")}`;
          } else if (prop.includes("engineRecordList")) {
            const fieldName = prop.split(".")[1];
            label = this.$t(recordFieldLabelMap[fieldName] || fieldName);
          } else if (prop.includes("transmissionRecordList")) {
            const fieldName = prop.split(".")[1];
            label = this.$t(recordFieldLabelMap[fieldName] || fieldName);
          } else if (propLabelMap[prop]) {
            label = this.$t(propLabelMap[prop]);
          }
          if (label && !errorLabels.includes(label)) {
            errorLabels.push(label);
          }
        });
      }
      if (errorLabels.length > 0) {
        this.$DonMessage.warning(`${errorLabels.join(", ")}`);
      } else {
        this.$DonMessage.warning(this.$t("restockInfo.required"));
      }
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (!this.getFileUploadTip()) {
          return;
        }
        if (!valid) {
          this.getErrorLocation();
          this.getRequiredTips(object);
          return;
        }
        const submitData = this.getFeedbackDetail();
        if (this.operate === "edit") {
          try {
            const res = await afterProblemEditApi({ data: submitData });
            if (res.status == 0) {
              this.dialogVisible = false;
              this.$DonMessage.success(this.$t("message.czcg"));
              this.$emit("success", submitData);
            } else {
              this.$DonMessage.error(res.message);
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          this.dialogVisible = false;
          this.$emit("success", submitData);
        }
      });
    },
  },
  mounted() {
    this.getTypeList();
  },
};
</script>

<style lang="scss" scoped>
// 保养记录样式
.maintenance-records {
  width: 100%;
  .record-item {
    border: 1px solid var(--line-color);
    border-radius: 4px;
    padding: 10px 15px;
    margin: 10px 0;
    position: relative;
    .remove-record {
      display: flex;
      align-items: center;
      justify-content: end;
      margin-bottom: 10px;
    }
    .remove-record-btn {
      font-size: 12px !important;
      color: #666;
    }
  }
}
</style>
